import { render, staticRenderFns } from "./HabitsCard.vue?vue&type=template&id=25b2d956&scoped=true"
import script from "./HabitsCard.vue?vue&type=script&lang=js"
export * from "./HabitsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b2d956",
  null
  
)

export default component.exports